import { fmt, LinkCard, PageHead, Section } from "@nabble/ui";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../auth/AuthContext";
import { capitalize, greetingFor } from "./greeting";
import { YourModules } from "./YourModules";

export default function OverviewPage(): React.JSX.Element {
  const { user } = useAuth();
  const navigate = useNavigate();
  const firstName = user?.displayName?.split(" ")[0] ?? "";
  const greeting = greetingFor(fmt.hourOfDay());

  return (
    <div>
      <PageHead
        title={firstName ? `${greeting}, ${firstName}` : greeting}
        subtitle={`${capitalize(fmt.weekdayDate())}. Here are the tools available to you.`}
      />

      <Section title="Your modules" description="Pick a module to get started.">
        <YourModules />
      </Section>

      <Section title="Your account">
        <div className="nb-grid nb-grid-links">
          <LinkCard title="Security" description="Password and second factor" icon="shield" onClick={() => navigate("/account/authentication")} />
          <LinkCard title="Open sessions" description="See where you're signed in" icon="monitor" onClick={() => navigate("/account/sessions")} />
        </div>
      </Section>
    </div>
  );
}
